// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3DmkN","approved":"Status_approved__ThYNK","rejected":"Status_rejected__3KQrA","expired":"Status_expired__3lYUf","label":"Status_label__9G6nO"};